<template>
    <el-popconfirm
        :confirm-button-text="confirmButtonText"
        :cancel-button-text="cancelButtonText"
        icon="el-icon-info"
        icon-color="red"
        :title="title"
        @onConfirm="delConfirm"
        @onCancel="delCancel"
    >
        <el-button slot="reference" type="text" size="small" @click="del"
            >删除</el-button
        >
    </el-popconfirm>
</template>

<script>
export default {
    name: "del-pop-confirm",
    props: {
        title: {
            type: String,
            default: "确定删除？"
        },
        confirmButtonText: {
            type: String,
            default: "删除"
        },
        cancelButtonText: {
            type: String,
            default: "取消"
        },
    },
    methods: {
        del() {
            this.$emit("del");
        },
        delConfirm() {
            this.$emit("delConfirm");
        },
        delCancel() {
        }
    }
};
</script>

<style></style>
